import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";
import ReactPlayer from 'react-player'

const ThumbImageHeightMobile = 230

export const Wraper = styled.div`
  position: relative;
  width: 100%;
  overflow: overlay;

  @media ${device.mobile} {
    height: calc(100% - 20px);
  }

  @media ${device.desktop} {
    height: 100%;
  }
`;

export const ThumbImage = styled.div`
  position: relative;
  width: 100%;
  height: ${ThumbImageHeightMobile}px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  @media ${device.desktop} {
    height: 240px;
    border-radius: 10px 10px 0px 0px;
  }
`;

export const Image = styled.img`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;
`;

export const Video = styled(ReactPlayer) `
  width: 100%;
  height: 100%;
`;

export const TotalBox = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 9px 15px;
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(3.5px);
  border-radius: 0px 10px 0px 0px;

  @media ${device.desktop} {
    padding: 7px 20px 6px 30px;
  }
`;

export const TotalText = styled.p`
  color: var(--text-color);
  font-weight: 500;
  font-size: 8px;
  line-height: 1.25;
`;

export const TotalSum = styled.p`
  color: var(--text-color);
  font-weight: 700;
  font-size: 15px;
  line-height: 1.22;

  @media ${device.desktop} {
    font-size: 18px;
  }
`;

type PropsContentBox = {
  mobileButtonsHeight?: number | null;
};

export const ContentBox = styled.div<PropsContentBox>`
  width: 100%;
  padding: 0px 10px 10px 10px;

  @media ${device.desktop} {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0 30px;
  }

  @media ${device.mobile} {
    overflow: auto;
    max-height: ${({ mobileButtonsHeight }) => mobileButtonsHeight ? `calc(100% - ${mobileButtonsHeight}px - ${ThumbImageHeightMobile}px - 45px)` : "100%"};
  }
`;

export const TextBox = styled.div`
  width: 100%;

  @media ${device.desktop} {
    margin-right: 50px;
  }
`;

export const BonusesContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;
  padding-inline: 10px;
  text-align: start;

  @media ${device.desktop} {
    position: relative;
    align-self: flex-end;
    width: 170px;
    height: 100%;
    margin-bottom: 0;
    padding-inline: 0px;
  }
`;

export const Title = styled.h1`
  margin-bottom: 10px;
  text-align: inherit;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
  color: var(--title-text-color);

  @media ${device.desktop} {
    margin-bottom: 20px;
    font-size: 25px;
  }
`;

export const SecondTitle = styled.h2`
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 13px; //11
  line-height: 1.27;
  color: var(--text-color);

  @media ${device.desktop} {
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const Text = styled.p`
  margin-bottom: 30px;
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.27;
  color: var(--text-color);

  @media ${device.desktop} {
    margin-bottom: 40px;
    font-size: 14px;
    line-height: 1.33;
  }
`;

export const BonusesTitle = styled.h3`
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 8px;
  line-height: 2;
  text-transform: uppercase;
  color: var(--text-color);
`;

export const ButtonBox = styled.div`
  @media ${device.mobile} {
    position: absolute;
    bottom: 10px;
    left: 0;
    display: block;
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  /* @media ${device.desktop} {
    left: 30px;
    width: calc(100% - 30px);
    text-align: start;
  } */
`;

type Props = {
  length?: number;
};

export const BoxBonuse = styled.div<Props>`
  @media ${device.mobile} {
    display: grid;
    grid-template-columns: minmax(90px, 1fr) minmax(90px, 1fr) repeat(
        auto-fit,
        minmax(90px, 1fr)
      );
    justify-content: center;
    grid-gap: 20px;
    width: 100%;
    margin-bottom: 10px;
    min-height: 60px;

    ${({ length }) => {
      if ((length ?? 0) > 2) {
        return `
        grid-gap: 5px;
        min-height: 40px;
    `;
      }
      return '';
    }}
  }

  @media ${device.desktop} {
    flex-direction: column;
    width: 100%;
    margin-bottom: 0;
  }
`;
